import { useMemo } from 'react';
import { getDefaultValues } from '../../../components/SearchForm/utils/getDefaultValues.js';
export const useDefaultValues = ({
  airports,
  travelPeriod
}) => {
  return useMemo(() => {
    return getDefaultValues({
      airports,
      travelPeriod
    });
  }, [airports, travelPeriod]);
};